import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { ArrowLeftIcon, ArrowRightIcon } from '@ninja/icons/web';
import { getTzIsSameYear, getTzIsSameMonth, getDuration, getTzStartOfMonth, addMonths, addDays, setTimeToDay, formatDate } from '@ninja/utilities';
import { useResponsiveView } from './useResponsiveView.js';
import styles from './DatePicker4.js';
import { checkIsValidRangeForDaysHeader } from './utils6.js';
import { useCalendarViewContext } from './components10.js';

const DaysViewHeader = () => {
    const { updateViewState, viewState: { tzDate, currentCalendar, intervalStartDate, intervalEndDate }, fromDate, toDate, enableTimeSelection, isIntervalPicker, maxSelectionRangeDays, } = useCalendarViewContext();
    const { sm } = useResponsiveView();
    const sameYear = !!fromDate && !!toDate && getTzIsSameYear(fromDate, toDate, currentCalendar);
    const sameMonth = !!fromDate && !!toDate && getTzIsSameMonth(fromDate, toDate, currentCalendar);
    let { allowNextMonth, allowPreviousMonth } = checkIsValidRangeForDaysHeader({
        isIntervalPicker,
        maxSelectionRangeDays,
        intervalStartDate,
        intervalEndDate,
        refDate: tzDate,
    });
    if (toDate) {
        const toDuration = getDuration(getTzStartOfMonth(toDate), getTzStartOfMonth(tzDate));
        allowNextMonth = allowNextMonth && (toDuration.months > 0 || toDuration.years > 0);
    }
    if (fromDate) {
        const fromDuration = getDuration(getTzStartOfMonth(tzDate), getTzStartOfMonth(fromDate));
        allowPreviousMonth = allowPreviousMonth && (fromDuration.months > 0 || fromDuration.years > 0);
    }
    const nextMonth = addMonths(tzDate, 1);
    return (jsxs(Fragment, { children: [jsx("div", { className: styles.navigationIconContainer(!allowPreviousMonth), onClick: () => {
                    if (allowPreviousMonth) {
                        const newTzDate = addMonths(addDays(getTzStartOfMonth(tzDate, currentCalendar), 2), -1);
                        updateViewState({
                            tzDate: enableTimeSelection ? setTimeToDay(tzDate, newTzDate) : newTzDate,
                        });
                    }
                }, children: jsx(ArrowLeftIcon, { className: styles.navigationIcon(!allowPreviousMonth) }) }), jsxs("div", { className: "flex flex-1 justify-center  gap-8", children: [jsx("div", { className: styles.dayViewLink.container, onClick: () => {
                            if (!sameMonth)
                                updateViewState({ viewMode: 'months' });
                        }, children: formatDate(tzDate, {
                            dateFormat: 'MMMM',
                            calendar: currentCalendar,
                        }) }), jsx("div", { className: styles.dayViewLink.container, onClick: () => {
                            if (!sameYear)
                                updateViewState({ viewMode: 'years' });
                        }, children: formatDate(tzDate, {
                            dateFormat: 'yyyy',
                            calendar: currentCalendar,
                        }) })] }), isIntervalPicker && !sm && (jsxs("div", { className: "flex flex-1 justify-center  gap-8", children: [jsx("div", { className: styles.dayViewLink.container, onClick: () => {
                            if (!sameMonth)
                                updateViewState({ viewMode: 'months' });
                        }, children: formatDate(nextMonth, {
                            dateFormat: 'MMMM',
                            calendar: currentCalendar,
                        }) }), jsx("div", { className: styles.dayViewLink.container, onClick: () => {
                            if (!sameYear)
                                updateViewState({ viewMode: 'years' });
                        }, children: formatDate(nextMonth, {
                            dateFormat: 'yyyy',
                            calendar: currentCalendar,
                        }) })] })), jsx("div", { className: styles.navigationIconContainer(!allowNextMonth), onClick: () => {
                    if (allowNextMonth) {
                        const newTzDate = addMonths(addDays(getTzStartOfMonth(tzDate, currentCalendar), 2), 1);
                        updateViewState({
                            tzDate: enableTimeSelection ? setTimeToDay(tzDate, newTzDate) : newTzDate,
                        });
                    }
                }, children: jsx(ArrowRightIcon, { className: styles.navigationIcon(!allowNextMonth) }) })] }));
};

export { DaysViewHeader };
